const CONSTANTS = {
    SHOW_IN_DEV: process.env.REACT_APP_ENV !== 'product',
    IS_PRODUCT: process.env.REACT_APP_ENV === 'product',
    EXCLUDE_SET: 'naver',
    CHART_SHOW_MAXIMUM_DATA: 48,
    ELIGA_ORDER_OPEN_YEAR: 2024,
    RFID_TIME_MAX_LIMIT: 180, //사원증 최대 유효시간
    SHOP_COPY_POLLING: 10,
    PASSWORD_REMINDER_DAYS: 90,
    RULES: {
        HAS_SAME_CHAR: /(.)\1\1/,
        TEMP_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{10,20}$/,
        PASSWORD: /^(?=.{10,20}$)((?=.*[A-Za-z])(?=.*[0-9])|(?=.*[A-Za-z])(?=.*[?!@&^~*#$+=])|(?=.*[0-9])(?=.*[?!@&^~*#$+=]))/,
        PASSWORD_CHAR: /((?=.*[A-Za-z])(?=.*[0-9])|(?=.*[A-Za-z])(?=.*[?!@&^~*#$+=])|(?=.*[0-9])(?=.*[?!@&^~*#$+=]))/,
        PASSWORD_LENGTH: /^.{10,20}$/,
        // PASSWORD 규칙
        // 길이: 10~20자리
        // 조합 조건: 아래 3가지 중 2가지 이상을 포함해야 함
        // - 영문자 (대소문자)
        // - 숫자 (0~9)
        // - 특수문자 (?!@&^~*#$+=)
        APP_PASSWORD_RULE: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[?!@&^~*#$+=])(?=.{8,}).*$/, // APP_PASSWORD_RULE: 엘리가오더 앱 비밀번호 규칙
        IS_NUMBER: /^\d+$/,
        EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        ONLY_NUMBER_CHAR: /^[A-Za-z0-9]+$/
    },
    FILE_CHUNK_SIZE: 5242880,
    FILE_UPPY_USE: true,
    FILE_TYPE: {
        EXCEL: '.xlsx, .xls'
    }
}
export default CONSTANTS;